export default "__VITE_ASSET__CvKRPKnU__"